export enum ProfileImportBannerType {
  Info = 'info',
  Warn = 'warn',
  Error = 'error'
}
